/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex'; 
export default {
  name: 'organization-details-update',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      name:'',
      address:'',
      city:'',
      pincode:'',
      country:'',
      activeStatus:Boolean,
      orgDetails:{}
    }
  },
  computed: {
    ...mapGetters([
      'OrgDetailByIdGetters'
    ]),
    getOrgDetailsByIdDetailsFun(){
      this.orgDetails = this.$store.getters.OrgDetailByIdGetters.data
      return
    },
    SetIntialStatus() {
      if (this.orgDetails != undefined) {
        this.name = this.orgDetails.name
        this.address = this.orgDetails.address
        this.city = this.orgDetails.city
        this.pincode = this.orgDetails.pincode
        this.country = this.orgDetails.country
        this.activeStatus = this.orgDetails.is_active
      }
    }
  },
  mounted () {
    this.getOrgDetailsByIdDetailsFun
    this.SetIntialStatus
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              name:this.name,
              address:this.address,
              city:this.city,
              pincode:this.pincode,
              country:this.country,
              is_active:this.activeStatus
            }
            this.$store.dispatch('updateAcOrgFun', {
              data:{
                data:data,
                id:this.$route.params.orgId}
            })
              .then((res) => {
                  toast.success(res.data.msg);            
                  this.$router.push('/su/organization/');
              }).catch((err) => {
                toast.error(err.data.user_msg);  
              })
            return;
        }
      });
    }
  },
  watch:{
    getOrgDetailsByIdDetailsFun(){
      return this.$store.getters.OrgDetailByIdGetters.data
    },
    SetIntialStatus() {
      if (this.orgDetails != undefined) {
        this.name = this.orgDetails.name
        this.address = this.orgDetails.address
        this.city = this.orgDetails.city
        this.pincode = this.orgDetails.pincode
        this.country = this.orgDetails.country
        this.activeStatus = this.orgDetails.is_active
      }
    }
  }
}


